export { default as modalAction } from './modal';

export default {};
